import './style.scss';
import React from 'react';
import unidecode from 'unidecode';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import _ from 'lodash';
import classNames from 'classnames';
import { Controller } from 'react-hook-form';
import InputTitle from '../../inputTitle';

const { Option } = Select;
const NormalSelect = (props) => {
  // need something to store selected items, can use state or ref.
  const onSearch = (value) => {
  };

  const onChangeNormal = (value, option) => {
    props.onChange(props.name, option);
  };

  const renderOptions = props.isObject
    ? _.map(props.options, option => (
      <Option key={option.value} value={option.value} data={option?.data}>{option.label}</Option>
    ))
    : _.map(props.options, option => (
      <Option key={option} value={option}>{option}</Option>
    ));
  const renderErrorMessage = () => (
    <div className="error-message mt-4">
      <p>{props.errMsg}</p>
    </div>
  );
  const renderSelect = (onChange, onBlur, value, ref) => (
    <Select
      ref={ref}
      placeholder={props.placeholder}
      allowClear={props.allowClear}
      showSearch={props.showSearch}
      loading={props.loading}
      optionFilterProp="children"
      disabled={props.disabled}
      mode={props.mode}
      value={value}
      getPopupContainer={() => document.getElementsByClassName('select-wrapper')[0]}
      options={props.mode !== 'multiple' ? props.options : undefined}
      defaultValue={props.defaultValue}
      onSearch={onSearch}
      onChange={onChange}
      onBlur={onBlur}
      notFoundContent={props.notFoundContent}
      filterOption={(input, option) => {
        const normalizeInput = unidecode(input.toLowerCase());
        if (props.isObject) {
          const normalizeFullLabel = unidecode(option?.label?.toLowerCase());
          return normalizeFullLabel?.includes(normalizeInput);
        }
        const normalizeFullValue = unidecode(option?.value?.toLowerCase());
        return normalizeFullValue?.includes(normalizeInput);
      }
      }
    >
      {renderOptions}
    </Select>
  );

  return (
    <div className={classNames('select-wrapper', props.className)} key={props.name}>
      {props.title && (
        <InputTitle className="mb-2" title={props.title} isRequired={props.isRequired} />
      )}
      {props.isUseForm ? (
        <Controller
          control={props.control}
          name={props.name}
          render={({
            field: {
              onChange, onBlur, value, ref,
            },
          }) => (
            <>
              {renderSelect((value, option) => {
                onChangeNormal(value, option);
                onChange(props.isObject ? option : value);
              }, onBlur, props.mode === 'multiple' ? [...value] : value, ref)}
            </>
          )}
        />
      ) : (
        <>
          {renderSelect(onChangeNormal, () => { }, props.value, undefined)}
        </>
      )}
      {props.errMsg && renderErrorMessage()}
    </div>
  );
};
NormalSelect.defaultProps = {
  className: '',
  title: '',
  name: '',
  isUseForm: false,
  isRequired: false,
  showSearch: true,
  placeholder: '',
  disabled: false,
  loading: false,
  mode: '',
  value: undefined,
  options: undefined,
  defaultValue: undefined,
  allowClear: false,
  isObject: true,
  notFoundContent: '',
  control: undefined,
  errMsg: '',
  onChange: () => {},
};
NormalSelect.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  isUseForm: PropTypes.bool,
  isRequired: PropTypes.bool,
  showSearch: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(), PropTypes.arrayOf(PropTypes.string)]),
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape()), PropTypes.arrayOf(PropTypes.string)]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  allowClear: PropTypes.bool,
  isObject: PropTypes.bool,
  notFoundContent: PropTypes.string,
  control: PropTypes.shape(),
  errMsg: PropTypes.string,
  onChange: PropTypes.func,
};
export default NormalSelect;
